import { Navigate, createFileRoute } from "@tanstack/react-router";

import { parseWorldsFilters } from "../../../workspaces/worlds/search";


export const Route = createFileRoute(
  "/_console/p/$org/$project/build-worlds/assets",
)({
  validateSearch: parseWorldsFilters,
  component: WorldAssetsRoute,
});

function WorldAssetsRoute() {
  return <Navigate to="/p/$org/$project/simulate" params={Route.useParams()} search={Route.useSearch()} replace />;
}
